import { getDropdownFun } from '../../../../api/infoAPI';
import errorHandle from '../../../../utils/errorHandle';

export const fetchTypesData = async (type, name, setTypesData) => {
    try {
        const filters = await getDropdownFun(type, name);
        const result = filters.data.dropdown.map((item) => ({
            value: item.name,
            text: item.displayName
        }));
        setTypesData(result);
    } catch (error) {
        errorHandle(error);
    }
};
